// @ts-ignore
import apiFetcher from '@/utils/interCeptor';

export interface CommonUploadedFile {
    id: number;
    fileName: string;
    filePath: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
}

const normalizeUploadedFiles = (response: any): CommonUploadedFile[] => {
    const responseData = response?.data?.data || response?.data || [];
    if (!Array.isArray(responseData)) return [];

    return responseData
        .map((item: any) => ({
            id: Number(item?.id),
            fileName: item?.file_name,
            filePath: item?.url,
            createdAt: item?.created_at,
            updatedAt: item?.updated_at,
            deletedAt: item?.deleted_at,
        }))
        .filter((item) => item.id && item.filePath);
};

export const createFilesApi = async ({ files }: { files: File[] }): Promise<CommonUploadedFile[]> => {
    try {
        const payload = new FormData();
        files.forEach((file) => {
            payload.append('files', file);
        });

        const response = await apiFetcher.post('/api/v1/store/file/multi', payload);
        return normalizeUploadedFiles(response);
    } catch (error) {
        throw new Error(error instanceof Error ? error.message : 'Failed to upload files');
    }
};

export const updateFileApi = async ({
    id,
    payload,
}: {
    id: number;
    payload: FormData | Record<string, any>;
}): Promise<CommonUploadedFile[]> => {
    try {
        const response = await apiFetcher.patch(`/api/v1/store/file/${id}`, payload);
        return normalizeUploadedFiles(response);
    } catch (error) {
        throw new Error(error instanceof Error ? error.message : 'Failed to update file');
    }
};

export const deleteFileApi = async ({ id }: { id: number }) => {
    try {
        return await apiFetcher.delete(`/api/v1/store/file/${id}`);
    } catch (error) {
        const normalizedError = new Error(error instanceof Error ? error.message : 'Failed to delete file') as Error & {
            status?: number;
        };
        normalizedError.status = (error as any)?.response?.status;
        throw normalizedError;
    }
};
